
export class Perfil {

	static GESTOR: string = "GES";
	static ADMINISTRADOR: string = "ADM";

	public cod_perfil: number;
	public sgl_perfil: string;
	public dsc_perfil: string;
}
